import { useEffect } from "react";
import { App } from "antd";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { getNotificationsState } from "../../store/selectors";
import { CLOSE_NOTIFICATION } from "../../constants";

const NotificationsHandler = () => {
  const { notification } = App.useApp();
  const state = useSelector(getNotificationsState, shallowEqual);
  const dispatch = useDispatch();

  useEffect(() => {
    if (state?.show && state.message) {
      const key = Date.now().toString();
      notification.open({
        key,
        type: state.status || "info",
        placement: "topRight",
        message: state.message,
        duration: 2,
        closeIcon: null,
        onClose: () => dispatch({ type: CLOSE_NOTIFICATION }),
      });
    }
  }, [state, dispatch, notification]);

  return null;
};

export default NotificationsHandler;